import { isPermitted } from '../../../components/permission-control/permission-control';
import { FORM_VIEW } from '../constants/form.permission';

/**
 * Forms tab visibility (Feeds and Re-Entry Planning), gated on `form_view`.
 * @param {{ cbacConfigFlag?: boolean, permissions?: object[], permissionIds?: number[] }} [global]
 * @returns {boolean}
 */
export const canViewFormsTab = ({ cbacConfigFlag, permissions, permissionIds } = {}) =>
  isPermitted(cbacConfigFlag, permissions, FORM_VIEW, permissionIds);
